import React from 'react';
import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

import messages from './messages';

function Confirmation(props) {
  const {
    children,
    open,
    loading,
    title,
    onClose,
    disabled,
    onConfirm,
    disableActions,
    disableTypography,
    typographyProps,
    maxWidth = 'sm',
    fullWidth: fullWidthProp = true,
    PaperProps,
  } = props;

  return (
    <Mui.Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidthProp}
      PaperProps={PaperProps}>
      <Mui.DialogTitle>{title || <FormattedMessage {...messages.title} />}</Mui.DialogTitle>
      <Mui.DialogContent>
        {disableTypography ? (
          children
        ) : (
          <Mui.DialogContentText color="textPrimary" {...typographyProps}>
            {children}
          </Mui.DialogContentText>
        )}
      </Mui.DialogContent>
      {!disableActions && (
        <Mui.DialogActions>
          <Mui.Box
            px={1}
            width="100%"
            display="flex"
            alignContent="center"
            alignItems="center"
            justifyContent="space-between">
            {onClose && (
              <Mui.Button
                color="secondary"
                variant="text"
                fullWidth={false}
                disabled={loading}
                onClick={onClose}>
                <FormattedMessage {...messages.closeButton} />
              </Mui.Button>
            )}
            {onConfirm && (
              <Mui.Button
                color="primary"
                variant="text"
                disabled={disabled}
                onClick={onConfirm}
                fullWidth={false}
                loading={loading}>
                <FormattedMessage {...messages.confirmButton} />
              </Mui.Button>
            )}
          </Mui.Box>
        </Mui.DialogActions>
      )}
    </Mui.Dialog>
  );
}

Confirmation.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  disableActions: PropTypes.bool,
  disableTypography: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.any,
  typographyProps: PropTypes.object,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
  PaperProps: PropTypes.object,
};

export default Confirmation;
